import styled from "styled-components/macro";
import Footer from "./Footer";

export const StyledPageWrapper = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: 100vh;
  overflow: hidden;
  .background {
    color: white;
    opacity: 0.12;
    position: absolute;
    top: 110px;
    left: -30px;
  }
  img {
    margin: auto;
  }
  background: ${({ theme }) => theme.background};

  background-size: 150% 150%;
  animation: bubbleGradient 8s ease infinite;

  @keyframes bubbleGradient {
    0% {
      background-position: 0% 0%, 0% 100%, 100% 0%, 100% 100%, 0% 0%;
    }
    50% {
      background-position: 100% 50%, 50% 0%, 0% 100%, 50% 50%, 100% 100%;
    }
    100% {
      background-position: 0% 0%, 0% 100%, 100% 0%, 100% 100%, 0% 0%;
    }
  }
  text-align: center;
  color: white;
  overflow-x: hidden;

  a:hover {
    text-decoration: none;
  }

  hr {
    margin: 20px 0px;
    border: 0;
    height: 1px;
    background-image: linear-gradient(
      to right,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255),
      rgba(255, 255, 255, 0)
    );
  }

  @media screen and (max-width: 1000px) {
    .company,
    .certification {
      display: none;
    }
  }
`;

export const PageWrapper = ({ children }: { children: React.ReactNode }) => (
  <StyledPageWrapper>
    {children}
    <Footer />
  </StyledPageWrapper>
);

export const HomePageWrapper = styled.div`
  width: 100%;
  background: radial-gradient(rgba(15, 130, 134, 0.39) 0%, #b49dfe 60%);
  text-align: center;
  color: white;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
  a:hover {
    text-decoration: none;
  }
`;
